$(document).ready(function(){
  $('#user-creation-validation').parsley();

  $(".switchLoginForm").on("click",function(){
    $("#we-help-two-user-form").hide();
    $("#we-help-two-login").show();
  });
  $(".switchRegistrationForm").on("click",function(){
    $("#we-help-two-user-form").show();
    $("#we-help-two-login").hide();
  });
  var newaccount = $('.new-account').attr('data-new-account');
  if(newaccount == "yes"){
    $("#we-help-two-user-form").hide();
    $("#we-help-two-login").show();
  }
});
